<template>
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body scroll-y">
          <table class="table table-striped table-hover table-bordered" id="my-table">
            <thead>
              <tr>
                <th class="w-25" v-if="organisation_id == null">{{ $t('organisation') }}</th>
                <th class="w-25">{{ $t('plant') }}</th>
                <th>{{ $t('price_per_month') }}</th>
                <th>{{ $t('new_price_per_month') }}</th>
                <th>{{ $t('price_valid_from') }}</th>
                <th>{{ $t('new_plant_price') }}</th>
                <th>{{ $t('new_price_valid_from') }}</th>
                <th>Push €/Mon.</th>
                <th>
                  <button class="btn btn-outline-success" @click="exportPdf()">
                    {{ $t('export_pdf') }}
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="plantPrice in sortedPlants" v-bind:key="plantPrice">
                <td :class="getTrCssClass(plantPrice)" v-if="organisation_id == null">
                  {{ plantPrice.organisation_bez }}
                </td>
                <td :class="getTrCssClass(plantPrice)">{{ plantPrice.plant_bez }}</td>
                <td :class="getTrCssClass(plantPrice)">{{ plantPrice.price_per_month }}</td>
                <td :class="getTrCssClass(plantPrice)">{{ plantPrice.new_price_per_month }}</td>
                <td :class="getTrCssClass(plantPrice)">{{ plantPrice.new_price_at_date }}</td>
                <td>
                  <input
                    type="number"
                    name="name"
                    class="form-control"
                    v-model="plantPrice.new_price"
                    :disabled="!plantPrice.is_billable"
                  />
                </td>
                <td>
                  <input
                    type="date"
                    name="name"
                    class="form-control"
                    v-model="plantPrice.new_price_at_date_new"
                    :disabled="!plantPrice.is_billable"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    class="form-control"
                    v-model="plantPrice.push_price_per_month"
                    :disabled="!plantPrice.is_billable"
                  />
                </td>
                <td>
                  <button
                    class="btn btn-success mb-0 ms-auto"
                    @click="updatePriceForPlant(plantPrice)"
                    :disabled="!plantPrice.is_billable"
                  >
                    {{ $t('update') }}
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th v-if="organisation_id == null">{{ sum_orgas }}</th>
                <th>{{ sum_plants }}</th>
                <th>{{ sum_plants_prices }}</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const fileDownload = require('js-file-download');
export default {
  name: 'PlantPriceOverview',
  props: {
    organisation_id: {
      type: String,
      required: false,
    },
  },
  components: {},
  data() {
    return {
      plantPrices: [],
    };
  },
  async mounted() {
    await this.getPrices();
  },
  updated() {},
  unmounted() {
    console.log('component unmounted');
  },
  methods: {
    exportPdf() {
      console.log('entry exportPdf');
      axios
        .get(`/api/v1/plant_price_overview/get_plant_price_overview`, { responseType: 'blob' })
        .then((response) => {
          console.log('response', response);
          fileDownload(response.data, `Preise_Anlagen_monatlich.pdf`);
        })
        .catch((error) => {
          console.log(JSON.stringify(error));
        });
      console.log('exit exportPdf');
    },
    getPrices() {
      console.log('entry updatePriceForPlant');
      let filter_price = '';
      if (this.organisation_id) {
        filter_price = `?organisation=${this.organisation_id}`;
      }
      axios
        .get(`/api/v1/plant_price_overview/` + filter_price)
        .then((response) => {
          this.plantPrices = response.data;
        })
        .catch((error) => {
          console.log(JSON.stringify(error));
        });
    },
    getTrCssClass(plantPrice) {
      if (!plantPrice.is_billable) {
        return 'table-disabled';
      } else if (this.checkPlantShouldHavePrice(plantPrice)) {
        return 'table-danger';
      }
      return '';
    },
    updatePriceForPlant(plantPrice) {
      console.log('entry updatePriceForPlant');
      let plantPriceUpdate = structuredClone(plantPrice);
      if (plantPrice.new_price_at_date_new) {
        plantPriceUpdate.new_price_at_date = plantPrice.new_price_at_date_new;
        plantPriceUpdate.new_price_per_month = plantPrice.new_price;
      } else {
        plantPriceUpdate.price_per_month = plantPrice.new_price;
        plantPriceUpdate.new_price_at_date = null;
        plantPriceUpdate.new_price_per_month = null;
      }
      axios
        .patch(`/api/v1/plant_price_overview/${plantPriceUpdate.id}/`, plantPriceUpdate)
        .then(() => {
          console.log('price updated');
          this.getPrices();
        })
        .catch((error) => {
          console.log(JSON.stringify(error));
        });
      console.log('exit updatePriceForPlant');
    },
    checkPlantShouldHavePrice(plantPrice) {
      return (
        plantPrice.organisation_bez != 'Anlagen Ohne Orga' &&
        plantPrice.price_per_month < 1 &&
        plantPrice.is_billable &&
        !plantPrice.is_view_orga_price
      );
    },
  },
  computed: {
    sortedPlants() {
      if (this.plantPrices.length == 0) return [];
      return [...this.plantPrices].sort((a, b) => {
        if (a.organisation_bez < b.organisation_bez) {
          return -1;
        }
        if (a.organisation_bez > b.organisation_bez) {
          return 1;
        }
        return 0;
      });
    },
    sum_orgas() {
      const uniqueValues = new Set(this.plantPrices.map((obj) => obj['organisation']));
      return 'Anzahl Organisationen: ' + uniqueValues.size;
    },
    sum_plants() {
      return 'Anzahl Anlagen: ' + this.plantPrices.length;
    },
    sum_plants_prices() {
      let sum_price = 0;
      this.plantPrices.forEach((element) => {
        if (element.is_billable) sum_price += parseFloat(element.price_per_month);
      });
      return sum_price;
    },
  },
};
</script>
